import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    value: []
}

export const itemsDataSlice = createSlice({
    name: 'itemsData',
    initialState,
    reducers: {
        setItemsData: (state, action) => {
            state.value = action.payload
        }
    }
})

export const { setItemsData } = itemsDataSlice.actions;
export default itemsDataSlice.reducer;